'use client';

import { alpha, Box, Card, CardContent, Skeleton } from '@mui/material';

import { PALETTE_KEYS } from '@/constants';

export const ProfitLossCardSkeleton = () => {
  return (
    <Card
      sx={{
        bgcolor: PALETTE_KEYS.BACKGROUND_PAPER,
        borderRadius: 4,
        border: '1px solid',
        borderColor: PALETTE_KEYS.DIVIDER,
        height: '100%',
        overflow: 'hidden',
      }}
    >
      <CardContent sx={{ p: 1.5 }}>
        {/* Header Skeleton — icon+label on left, 4 tiny range pills on right */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Skeleton
              variant="circular"
              width={14}
              height={14}
              sx={{ bgcolor: (theme) => alpha(theme.palette.text.primary, 0.1) }}
            />
            <Skeleton
              variant="text"
              width={80}
              height={18}
              sx={{ bgcolor: (theme) => alpha(theme.palette.text.primary, 0.1) }}
            />
          </Box>
          <Box sx={{ display: 'flex', gap: 0.5 }}>
            {[1, 2, 3, 4].map((i) => (
              <Skeleton
                key={i}
                variant="rectangular"
                width={32}
                height={20}
                sx={{
                  borderRadius: 0.8,
                  bgcolor: (theme) => alpha(theme.palette.text.primary, 0.05),
                }}
              />
            ))}
          </Box>
        </Box>

        {/* Stats Skeleton */}
        <Box sx={{ mb: 1.5 }}>
          <Skeleton
            variant="text"
            width={120}
            height={32}
            sx={{ bgcolor: (theme) => alpha(theme.palette.text.primary, 0.1) }}
          />
          <Skeleton
            variant="text"
            width={70}
            height={16}
            sx={{ bgcolor: (theme) => alpha(theme.palette.text.primary, 0.1) }}
          />
        </Box>

        {/* Chart Area Skeleton — smooth-area-chart silhouette, not discrete bars */}
        <Box sx={{ height: 140, width: '100%', overflow: 'hidden' }}>
          <Skeleton
            variant="rectangular"
            width="100%"
            height="100%"
            sx={{
              bgcolor: (theme) => alpha(theme.palette.text.primary, 0.05),
              clipPath:
                'polygon(0% 70%, 8% 58%, 16% 63%, 24% 42%, 32% 50%, 40% 28%, 48% 38%, 56% 18%, 64% 32%, 72% 22%, 80% 40%, 88% 30%, 96% 46%, 100% 36%, 100% 100%, 0% 100%)',
            }}
          />
        </Box>
      </CardContent>
    </Card>
  );
};

export default ProfitLossCardSkeleton;
